import { createTheme } from '@mui/material/styles';
import {
  BETHEL_BLUE,
  REFORMED_NAVY,
  SKY_BLUE,
  PALE_BLUE_MIST,
  PARCHMENT,
  LINEN,
  SOFT_WHITE,
  CHARCOAL,
  INK,
  STONE_GRAY,
  WARM_STONE,
  OLIVE_SAGE,
  OXBLOOD,
  BRASS,
  MUTED_GREEN,
  WARM_TERRACOTTA,
} from './colors';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: BETHEL_BLUE,
      light: SKY_BLUE,
      dark: REFORMED_NAVY,
    },
    secondary: {
      main: PARCHMENT,
    },
    background: {
      default: SOFT_WHITE,
      paper: SOFT_WHITE,
    },
    text: {
      primary: CHARCOAL,
      secondary: STONE_GRAY,
    },
    success: {
      main: MUTED_GREEN,
    },
    warning: {
      main: WARM_TERRACOTTA,
    },
    error: {
      // The brand palette defines one alert tone (Warm Terracotta) rather
      // than a separate, harsher error red - see CLAUDE.md.
      main: WARM_TERRACOTTA,
    },
    // Brand tokens with no standard MUI palette slot. Reach for these
    // (theme.palette.brand.*) before hardcoding a hex value.
    brand: {
      ink: INK,
      mist: PALE_BLUE_MIST,
      linen: LINEN,
      border: WARM_STONE,
      sage: OLIVE_SAGE,
      oxblood: OXBLOOD,
      brass: BRASS,
    },
  },
  typography: {
    // Only three fonts are used anywhere on the site (outside the Ezra
    // and Coffee pages, which keep their own branding - see CLAUDE.md):
    fontFamily: "'Montserrat', sans-serif", // headings, buttons, nav, labels
    secondaryFontFamily: "'Cormorant Garamond', serif", // main display / sermon titles
    paragraphFontFamily: "'Source Sans 3', sans-serif", // body copy
    scriptureFontFamily: "'Cormorant Garamond', serif", // Scripture / pull quotes - pair with fontStyle: 'italic'
    cardFontFamily: "'Montserrat', sans-serif",
  },
});

export default theme;
